export default __webpack_public_path__ + "static/media/library.5e9ecfe6.webp";